import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../common/chart/chartContainer/Line'
import { Legend } from '../../../../../common/chart/legend'
import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import {
  convertData,
  formatVal,
  isInValidValue,
  valToPercent,
} from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeChecked, selectChecked } from '../../store/slice'
import { TREND_DATA } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const chartId = useRef(getUnique())
  const dispatch = useDispatch()

  const {
    formatedUnit,
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    currency,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    TREND_DATA.filter((item) => item.isLineChart).map((item) => item.value),
  )

  const checkboxs = TREND_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )
  const groupStackBarKeys = bars.map((bar) => bar.value)

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const isNotHasBar = !bars.length

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicReport || isDownloadComponent,
          isNoData,
          332,
        ),
      }}
      className="dFlex"
    >
      <div className="flexColumn w60 h100">
        <Element
          className={`${classes.pdb6} ${classes.mt6}`}
          style={{ color: '#9C9C9C' }}
        >
          {!isNotHasBar ? formatedUnit : <>&nbsp;</>}
        </Element>
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            top: 10,
            bottom: 0,
            left: isNotHasBar || isDownloadComponent ? 16 : 0,
            right: isDownloadComponent ? 16 : 0,
          }}
          width="100%"
          height="100%"
          xAxis={[
            {
              dataKey: 'year',
              height: 30,
              tickFormatter: (value) => '‘' + String(value).slice(-2),
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: bars.map((item) => item.value),
              isStackedBar: true,
              tickFormatter: (value) =>
                formatVal(value, locale, undefined, currency === 'VND' ? 0 : 2),
              hide: isNotHasBar,
            },
            {
              yAxisId: 'right',
              orientation: 'right',
              dataKeys: lines.map((item) => item.value),
              isLineChart: true,
              unit: '%',
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...bars.map((bar) => ({
                  dataKey: bar.value,
                  label: bar.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
                ...lines.map((line) => ({
                  dataKey: line.value,
                  label: line.title,
                  formatValue: (value) => valToPercent(value, locale, true),
                })),
              ],
            },
          }}
        >
          {bars.map((bar, barIndex) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              stackId="stack"
              maxBarSize={25}
              showLabelEmpty={({ index }) =>
                barIndex === 0 &&
                groupStackBarKeys.every((dataKey) =>
                  isInValidValue(dataConvert[index][dataKey]),
                )
              }
            />
          ))}
          {lines.map((line) => (
            <Line
              key={line.value}
              yAxisId="right"
              dataKey={line.value}
              stroke={line.color}
              dot={{ fill: line.color }}
            />
          ))}
        </ChartContainer>
      </div>
      <div className="h100 w40 pl2 dFlex alignItemsCenter justifyContentCenter">
        <Legend
          chartId={chartId.current}
          items={checkboxs.map((item) => ({
            title: item.title,
            value: item.value,
            dataKey: item.value,
            color: item.color,
            isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
            listCheckBox: checked,
            setListCheckBox: setChecked,
            isI18n: false,
            isDynamicReport: isDynamicReport || isDownloadComponent,
          }))}
          className="flexColumn"
          style={{ gap: 3 }}
        />
      </div>
    </div>
  )
}

export default Trend
